export default __webpack_public_path__ + "static/services-banner-c6446e01224b08f019329a16e1793961.jpg";